export default __webpack_public_path__ + "static/media/Foco-Regular.7fd50336.ttf";